import { useState } from "react";
import { MessageCircle, ArrowRight } from "lucide-react";
import { buildWhatsAppUrl, trackEvent } from "@/lib/utm";

const models = [
  {
    key: "walk",
    name: "WALK",
    render: "/images/modelo_walk_render_3d.png",
    desc: "Cubierta peatonal continua para andadores y pasillos exteriores.",
    ideal: "Escuelas · Andenes · Corporativos",
  },
  {
    key: "curve",
    name: "CURVE",
    render: "/images/modelo_curve_render_3d.png",
    desc: "Módulo curvo individual con máxima resistencia al viento.",
    ideal: "Estacionamientos · Áreas residenciales",
  },
  {
    key: "curve-corto",
    name: "CURVE CORTO",
    render: "/images/modelo_curve_render_3d.png",
    desc: "Versión compacta del Curve, ideal para espacios pequeños y laterales.",
    ideal: "Residencial · Terrazas · Entradas",
  },
  {
    key: "sun",
    name: "SUN",
    render: "/images/modelo_sun_render_3d.png",
    desc: "Parasol piramidal de alto impacto visual para plazas y áreas comunes.",
    ideal: "Plazas · Parques · Áreas deportivas",
  },
  {
    key: "b2b",
    name: "BACK TO BACK",
    render: "/images/modelo_back_to_back_render_3d.png",
    desc: "Doble módulo espalda con espalda, cubre grandes áreas con menos columnas.",
    ideal: "Estacionamientos industriales · Escuelas grandes",
  },
];

export default function Models() {
  const [active, setActive] = useState(null);
  const wa = buildWhatsAppUrl(
    "5218116289267",
    "Hola Eclipse, no se cual modelo de FlexShade necesito, pueden asesorarme?"
  );

  return (
    <section id="modelos" className="py-20 md:py-28 bg-white" aria-label="Modelos FlexShade">
      <div className="container-x">
        <div className="text-center mb-12 md:mb-16">
          <span className="eyebrow">Los 5 Modelos</span>
          <h2 className="mt-4 section-title text-4xl md:text-6xl font-black">
            Un modelo para <span className="text-red-600">cada espacio</span>
          </h2>
          <p className="mt-4 text-neutral-600 max-w-2xl mx-auto">
            Sistema modular prefabricado FlexShade. Se adapta a cualquier tipo de proyecto con la misma calidad y garantía Eclipse.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {models.map((m) => (
            <button
              key={m.key}
              onMouseEnter={() => setActive(m.key)}
              onMouseLeave={() => setActive(null)}
              onClick={() => {
                trackEvent("model_click", { model: m.key });
                document.getElementById("cotizar")?.scrollIntoView({ behavior: "smooth" });
              }}
              className={`card-lift text-left bg-white rounded-2xl border-2 p-4 md:p-5 ${
                active === m.key ? "border-orange-500 shadow-xl" : "border-neutral-200 shadow-sm"
              }`}
              data-testid={`model-${m.key}`}
            >
              <div className="aspect-square bg-neutral-50 rounded-xl mb-3 overflow-hidden flex items-center justify-center p-3">
                <img src={m.render} alt={`Modelo FlexShade ${m.name}`} className="w-full h-full object-contain" loading="lazy" />
              </div>
              <h3 className="font-black text-xl md:text-2xl tracking-wide section-title">{m.name}</h3>
              <p className="text-xs md:text-sm text-neutral-600 mt-1 min-h-[3rem]">{m.desc}</p>
              <p className="mt-3 text-[0.7rem] md:text-xs font-semibold text-red-600 uppercase tracking-wider">{m.ideal}</p>
            </button>
          ))}
        </div>

        <div className="mt-12 text-center bg-neutral-50 rounded-2xl p-6 md:p-8 border border-neutral-200">
          <p className="text-neutral-800 font-semibold text-lg md:text-xl">
            ¿No sabes qué modelo necesitas?
          </p>
          <p className="text-neutral-600 mt-1">Te asesoramos sin costo, en 24 horas.</p>
          <a
            href={wa}
            target="_blank"
            rel="noreferrer"
            onClick={() => trackEvent("whatsapp_click", { location: "models_cta" })}
            className="btn-wa mt-5 px-6 py-3 rounded-xl inline-flex items-center gap-2"
          >
            <MessageCircle className="w-5 h-5" /> Hablar con un asesor
          </a>
        </div>
      </div>
    </section>
  );
}
